/* Simple remote logger that uses cevent */
import {
    K_TRACE, K_DEBUG, K_INFO, K_WARN, K_ERROR, K_SILENT, K_ENGINE, K_DEFAULT_EV,
    K_EVENT_TYPE, K_CLIENT, K_LEVEL, K_UP, K_SEND
} from 'up.lib.js.constants';
import { getIn } from 'up.lib.js.swissknife';

const MSG_PREFIX = 'PDX logger error: ';
const MSG_NO_SUCH_LEVEL = `${MSG_PREFIX}no such level! Only :\n trace, debug, info, warn, error or silent`;
const MSG_NO_SUCH_OPTION = `${MSG_PREFIX}no such option!`;


const levels = {};
levels[K_TRACE] = 0;
levels[K_DEBUG] = 1;
levels[K_INFO] = 2;
levels[K_WARN] = 3;
levels[K_ERROR] = 4;
levels[K_SILENT] = 5;

const _config = {};
_config[K_DEFAULT_EV] = {};
_config[K_EVENT_TYPE] = K_CLIENT;
_config[K_LEVEL] = K_INFO;
_config[K_ENGINE] = K_UP;

/* global BUILD_ENV*/

function upSend(msg) {
    const send = getIn(window, [K_UP, K_SEND]);
    if (typeof send === 'function') {
        send(msg);
    }
}

function set_env(msg){
    let set_env = 'PRD';
    if (typeof BUILD_ENV === 'undefined') {
        msg.noenv = 1;
    } else {
        set_env = BUILD_ENV;
    }
    msg.env = set_env;

    return msg;
}

function cevent(eventType, ec, ea, el, ev) {
    let msg = {
        ec,
        ea,
        el,
        ev: JSON.stringify(ev),
        t: eventType
    };
    msg = set_env(msg);
    upSend(msg);
}

export function set(key, value) {
    if (key in _config) {
        if (key === K_LEVEL) {
            if (value in levels) {
                _config[key] = value;
            } else {
                throw new Error(MSG_NO_SUCH_LEVEL);
            }
        } else if (key === K_DEFAULT_EV && typeof value === 'object') {
            _config[key] = merge(_config[key], value);
        } else {
            _config[key] = value;
        }
    } else {
        throw new Error(MSG_NO_SUCH_OPTION);
    }
}

export function get(key) {
    if (key in _config) {
        return _config[key];
    }
    throw new Error(MSG_NO_SUCH_OPTION);
}

function merge(d1 = {}, d2 = {}) {
    const d = {};
    Object.keys(d1).forEach((key) => {
        d[key] = d1[key];
    });
    Object.keys(d2).forEach((key) => {
        d[key] = d2[key];
    });
    return d;
}

function _log(ec, ea, el, ev) {
    cevent(_config[K_EVENT_TYPE], ec, ea, el, merge(_config[K_DEFAULT_EV], ev));
}


function _logN(level, args) {
    if (level >= levels[_config[K_LEVEL]]) {
        _log(...args);
    }
}

export function trace(...args) {
    _logN(levels[K_TRACE], args);
}

export function debug(...args) {
    _logN(levels[K_DEBUG], args);
}

export function info(...args) {
    _logN(levels[K_INFO], args);
}

export function warn(...args) {
    _logN(levels[K_WARN], args);
}

export function error(...args) {
    _logN(levels[K_ERROR], args);
}

export function raw(level, ec, ea, el, ev) {
    if (level in levels && levels[level] >= levels[_config[K_LEVEL]]) {
        cevent(_config[K_EVENT_TYPE], ec, ea, el, merge(_config[K_DEFAULT_EV], ev));
    }
}

export function transaction(eventObj) {
    let msg = {};
    msg.t = 'transaction';
    msg.v = 2;
    msg.st = eventObj.subtype;
    msg.data = eventObj.data;
    msg = set_env(msg);
    upSend(msg);
}
